import Yup from "../../helpers/customValidation";
let validationSchema = Yup.object({
  label: Yup.string("Label is Required").required("Label is Required"),
  
  
      
  });
  
  
  export default validationSchema;